import { RoleEnum } from 'src/common/external/bambi-api/bambiApi';

import { baseUserTypes } from './baseUserTypes';
import { rideOrderingPortalUserTypes } from './rideOrderingPortalUserTypes';

export const nonFacilityRolesThatCanCreateFacilityMemberships: RoleEnum[] = [
  'owner',
  'admin',
  'bambi',
];

export function getCreateableUserTypes(
  isRideOrderingPortalEnabledForOrganization: boolean,
  currentRole?: RoleEnum,
  roleOfUserBeingEdited?: RoleEnum
) {
  // This should be hidden from the UI, but just in case
  if (currentRole === 'facility user') {
    return [];
  }

  if (roleOfUserBeingEdited && baseUserTypes.includes(roleOfUserBeingEdited)) {
    return baseUserTypes;
  }

  if (
    roleOfUserBeingEdited &&
    rideOrderingPortalUserTypes.includes(roleOfUserBeingEdited)
  ) {
    return rideOrderingPortalUserTypes;
  }

  if (currentRole === 'facility admin') {
    return rideOrderingPortalUserTypes;
  }

  if (
    currentRole &&
    isRideOrderingPortalEnabledForOrganization &&
    nonFacilityRolesThatCanCreateFacilityMemberships.includes(currentRole)
  ) {
    return [...baseUserTypes, ...rideOrderingPortalUserTypes];
  }

  return baseUserTypes;
}
